module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_link_button_camera-e2eb4b426b0b70436d56bd844ec937f0.svg";